module.exports = __webpack_public_path__ + "static/financial-planning-hero-mobile.54a8f1b6.webp";